<div fxLayoutAlign.gt-md="space-between center" fxLayout.lt-md="column">
  <h1>Status das inscrições</h1>
  <div>
    <mat-form-field appearance="outline">
      <mat-label>Período Letivo</mat-label>
      <mat-select [(value)]="anoSelecionado" (selectionChange)="getData()">
        <mat-option *ngFor="let ano of anos" [value]="ano">
          {{ ano }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<form [formGroup]="form">
  <mat-form-field appearance="outline" fxFill>
    <mat-icon matSuffix (click)="filtrar()">search</mat-icon>
    <mat-label>Pesquisar por CPF</mat-label>
    <input
      matInput
      formControlName="cpf"
      type="search"
      mask="000.000.000-00"
      [dropSpecialCharacters]="true"
      (keydown.enter)="filtrar()"
      placeholder=""
      #input />
  </mat-form-field>
</form>

<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource">
    <caption></caption>
    <ng-container matColumnDef="detalhes">
      <th mat-header-cell *matHeaderCellDef>Inscrição</th>
      <td mat-cell data-label="Inscrição" *matCellDef="let row">
        <b>Discente</b>: {{ row.nome }}<br />
        <b>CPF</b>: {{ row.cpf }}<br />
        <b>ID</b>: {{ row.id }}<br />
        <b>Câmpus</b>: {{ row.campus }} {{ row.sigla }}<br />
        <b>Departamento</b>: {{ row.programa }}<br />
        <b>Disciplina</b>: {{ row.disciplina }} - {{ row.codigo }}<br />
        <b>Período</b>: {{ row.ano }} {{ row.semestre }}
      </td>
    </ng-container>
    <ng-container matColumnDef="resumo">
      <th mat-header-cell *matHeaderCellDef>
        Etapas<br /><span class="nota-details"
          >A etapa posterior estará disponível somente após a conclusão da anterior.</span
        >
      </th>
      <td mat-cell data-label="Etapas" *matCellDef="let row">
        <table style="width: unset">
          <caption></caption>
          <tr>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <td>1- Inscrição</td>
            <td>
              <div [className]="row.aprovado === 'APROVADA' ? 'success' : 'fail'">{{ row.aprovado }}</div>
            </td>
          </tr>
          <tr>
            <td>2- Carga horária prevista lançada</td>
            <td>
              <div [className]="row.cargaHorariaPrevistaLancada === 'SIM' ? 'success' : 'fail'">
                {{ row.cargaHorariaPrevistaLancada }}
              </div>
            </td>
          </tr>
          <tr>
            <td>3- Upload plano de atividades assinado pelo docente</td>
            <td>
              <div [className]="row.planoEntregue === 'SIM' ? 'success' : 'fail'">{{ row.planoEntregue }}</div>
            </td>
          </tr>
          <tr>
            <td>4- Plano de atividades com carga horária prevista</td>
            <td>
              <div [className]="row.planoAprovado === 'APROVADO' ? 'success' : 'fail'">{{ row.planoAprovado }}</div>
            </td>
          </tr>
          <tr>
            <td>
              5- Vínculo no sistema da graduação (SISGRAD)<a
                (click)="scrollTo('vinculo-sisgrad')"
                title="Clique para obter mais informações">
                <mat-icon class="icon-small">help</mat-icon>
              </a>
            </td>
            <td>
              <div [className]="row.vinculoAcademico === 'REALIZADO' ? 'success' : 'fail'">
                {{ row.vinculoAcademico }}
              </div>
            </td>
          </tr>
          <tr>
            <td>6- Plano de atividades com carga horária efetivada</td>
            <td>
              <div [className]="row.cargaHorarioEfetivaLancada === 'REGISTRADA' ? 'success' : 'fail'">
                {{ row.cargaHorarioEfetivaLancada }}
              </div>
            </td>
          </tr>
          <tr>
            <td>7- Relatório entregue pelo discente</td>
            <td>
              <div [className]="row.relatorioEntregue === 'SIM' ? 'success' : 'fail'">{{ row.relatorioEntregue }}</div>
            </td>
          </tr>
          <tr>
            <td>8- Relatório aprovado pelo docente responsável</td>
            <td>
              <div [className]="row.relatorioAprovadoDocenteResponsavel === 'APROVADO' ? 'success' : 'fail'">
                {{ row.relatorioAprovadoDocenteResponsavel }}
              </div>
            </td>
          </tr>
          <tr>
            <td>9- Relatório homologado pelo chefe do departamento</td>
            <td>
              <div [className]="row.relatorioHomologadoChefeDepartamento === 'HOMOLOGADO' ? 'success' : 'fail'">
                {{ row.relatorioHomologadoChefeDepartamento }}
              </div>
            </td>
          </tr>
        </table>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
    <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="2">
        <span *ngIf="input.value">Nenhum registro encontrado para a pesquisa: "{{ input.value }}"</span>
        <span *ngIf="!input.value">Nenhum registro disponível</span>
      </td>
    </tr>
  </table>
  <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
</div>

<div *ngIf="this.dataSource.data.length > 0">
  <br />
  <mat-card class="card-warning">
    <p class="mb0">
      Entrar em contato com o <b>DEPARTAMENTO DE ENSINO</b> caso haja <span class="fail">PENDÊNCIA</span> com:
    </p>
    <ul>
      <li>inscrição;</li>
      <li>plano de atividades com carga horária prevista;</li>
      <li>vínculo no sistema da graduação (SISGRAD);</li>
      <li>homologação do relatório.</li>
    </ul>
    <p class="mb0">
      Entrar em contato com o <b>DOCENTE RESPONSÁVEL</b> PELA DISCIPLINA caso haja
      <span class="fail">PENDÊNCIA</span> com:
    </p>
    <ul>
      <li>plano de atividades com carga horária efetivada;</li>
      <li>relatório que deve ser aprovado por ele.</li>
    </ul>
  </mat-card>
  <br />
  <mat-card class="card-danger">
    <p>O CERTIFICADO SERÁ EMITIDO SOMENTE APÓS TODAS AS ETAPAS REALIZADAS.</p>
  </mat-card>
  <br />
  <mat-card class="card-secondary" id="vinculo-sisgrad">
    <p>
      * <b>Vínculo no sistema da graduação (SISGRAD)</b>: é a etapa feita no sistema online da graduação após a
      aprovação do plano de atividades com carga horária prevista.<br />
      1- O SISPAADES envia ao SISGRAD o nome do aluno, o identificador da disciplina, o ano e o semestre que o discente
      selecionou.<br />
      2- No SISGRAD é feito o oferecimento de disciplina para o discente.<br />
      3- Após essa etapa o SISPAADES toma conhecimento do docente responsável pela disciplina e de todos os dados do
      PAADES até a finalização com a emissão do certificado.
    </p>
  </mat-card>
</div>
